export const activityUrl = 'activity/';
export const typesUrl = `${activityUrl}types/`;
export const typeGroupsUrl = `${activityUrl}type-groups/`;
export const absenceTypeParams = { acty_type: 'absence' };
export const resourceUsersUrl = 'users/resource_users/';
export const vacationBalanceUrl = 'users/vacation_balance/';

export const absenceUrl = `${activityUrl}absence/`;
export const holidaysUrl = `${activityUrl}holidays/`;
export const absenceLockUrl = `${absenceUrl}lock/`;
export const absenceLockHeartbeatUrl = `${absenceLockUrl}heartbeat/`;
export const absenceLockReleaseUrl = `${absenceLockUrl}release/`;
export const absenceDeleteUrl = `${absenceUrl}delete/`;
export const absenceRequestUrl = `${absenceUrl}request/`;
export const absenceApproveUrl = `${absenceUrl}approve/`;
export const absenceRejectUrl = `${absenceUrl}reject/`;
export const absenceApproveHrUrl = `${absenceUrl}approve-hr/`;
export const absenceRejectHrUrl = `${absenceUrl}reject-hr/`;
export const groupStatsUrl = `${typeGroupsUrl}group-stats/`;
